import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card'
import { Label } from '../../../ui/label'
import { FileUpload } from '../../file-upload'
import { LogoPreview } from '../../logo-preview'

import { AlertCircle } from 'lucide-react'

interface OverviewLogoSectionProps {
  localData: { logo: File | null; logoUrl?: string }
  errors: Record<string, string>
  logoUploading: boolean
  logoUploadError?: string
  onLogoSelected: (file: File | null) => void
  requestChanges?: Record<string, string>
}

export function OverviewLogoSection({
  localData,
  errors,
  logoUploading,
  logoUploadError,
  onLogoSelected,
  requestChanges,
}: OverviewLogoSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Project Logo</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-12 gap-6">
          <div className="md:col-span-8 space-y-2" id="logo">
            <Label>Logo Upload</Label>
            <FileUpload
              mode="image"
              accept="image/png"
              buttonLabel="Upload PNG"
              helperText="Upload a square 512×512px PNG"
              maxSizeMB={1}
              errorStrings={{
                fileCount: 'Please upload one image.',
                fileType: 'PNG only. Please upload a .png file.',
                fileSize: 'File is too large (max 1 MB).',
                unreadable:
                  "We couldn't read this image. Please try another file.",
                generic: 'Upload failed. Please try again.',
              }}
              ariaLabel="Upload company logo PNG file"
              onFileSelect={onLogoSelected}
              externalUploading={logoUploading}
              externalError={logoUploadError}
              currentFile={localData.logo}
              error={errors.logo}
            />
            <div className="flex flex-col gap-1">
              {requestChanges?.logo && (
                <p className="text-status-error text-xs inline-flex items-center gap-1">
                  <AlertCircle className="w-3 h-3" />
                  {requestChanges.logo}
                </p>
              )}
            </div>
          </div>
          <div className="md:col-span-4 space-y-2">
            <Label>Live Preview</Label>
            <LogoPreview
              logo={localData.logo}
              fallbackUrl={localData.logoUrl}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
